(function () {
  'use strict';

  angular.module('wsLrs.services').factory('Alerts', ['$rootScope', '$interval', '$sce', '$timeout', '$q', 'User', 'Api', '$http', function ($rootScope, $interval, $sce, $timeout, $q, User, Api, $http) {
    return {
      _pollingPromise: null,
      _pollingFrequency: 1000 * 60 * 5,
      _autoDismissTimeout: 1000 * 7,
      _since: null,
      startAlertsPolling: function startAlertsPolling() {
        var self = this;
        if (self._pollingPromise !== null) {
          return;
        }
        self._pollingPromise = $interval(self.refreshAlerts.bind(self), self._pollingFrequency);
        window.alerts = this;
      },
      refreshAlerts: function refreshAlerts() {
        var self = this;
        self.fetchAlerts().then(function (alerts) {
          angular.forEach(alerts, function (alert) {
            self.raiseAlert(alert);
          });
        });
      },
      fetchAlerts: function fetchAlerts() {
        var user = User.get(),
          userId = user.user ? user.user.id : null,
          organizationId = user.organization ? user.organization.id : null,
          self = this,
          alertsUrl = Api.url('/users/' + userId + '/alerts', true),
          alertsParams = {
            "organizationId": organizationId,
            "unreadOnly": true,
            "sortBy": "-created",
            "limit": 100
          };
        if (self._since !== null) {
          alertsParams.since = self._since;
        }
        if (userId === null || organizationId === null) {
          var result = $q.defer();
          result.resolve([]);
          return result.promise;
        }
        return $http.get(alertsUrl, {
          params: alertsParams
        }).then(function (response) {
          var results = response.data.results;
          if (results.length > 0) {
            self._since = results[0].created;
          }
          return results;
        });
      },
      raiseAlert: function raiseAlert(alert) {
        var self = this;
        if (typeof alert.created === "undefined") {
          alert.created = new Date().toISOString();
        }
        $rootScope.$emit('alert-received', alert);
        if (typeof alert.id === "undefined" && alert.autoDismiss !== false) {
          $timeout(function () {
            self.markAsRead(alert);
          }, alert.autoDismissTimeout || self._autoDismissTimeout);
        }
      },
      markAsRead: function markAsRead(alert) {
        alert.read = true;
        if (typeof alert.id !== "undefined") {
          $http.put(Api.url('/alerts/' + alert.id, true), alert);
        }
      }
    };
  }]);
})();
